const plugin = require('tailwindcss/plugin');

export const purge = ["./src/**/*.{html,ts}"];
export const darkMode = false;
export const important = true;
export const theme = {
  extend: {
    colors: {
      "adminis-green": {
        10: "#F0F8EC",
        500: "#68B845",
      },
      "adminis-grey": {
        500: "#474648",
      },
      "primary-4": "#9F9F9F",
      "primary-2": "#474648",
      "primary": "var(--primary-color)",
      "secondary": "var(--secondary-color)",
      "action-blue": "var(--action-color)",
      "warning-orange": {
        10: "#F9EBE6",
        500: "#C53B00",
      },
      fontSize: {
        xxs: '0.625rem',
      }
    },
    fontFamily: {
      sans: ["Roboto", "sans-serif"],
    },
    animation: {
      'loading-rotate': 'spin 2s linear infinite',
      'loading-bounce': 'loading-bounce 2s ease-in-out infinite',
    },
    keyframes: {
      "loading-bounce": {
        '0%, 100%': { transform: 'scale(0)' },
        '50%': { transform: 'scale(1)' },
      }
    },
    flex: {
      '2': '2 2 0%'
    },
    borderRadius: {
      DEFAULT: '5px',
    }
  }
};
export const experimental = {
  optimizeUniversalDefaults: true
};
export const plugins = [
  plugin(({ matchUtilities, theme }) => {
    matchUtilities(
      {
        "animate-delay": (value) => {
          return {
            "animation-delay": value,
          };
        },
      },
      {
        values: theme("transitionDelay"),
      }
    );
  }),
  plugin(function({ addUtilities, theme }) {
    addUtilities({
      '.stroke-action-blue': {
        stroke: theme('colors.action-blue'),
      },
      '.fill-action-blue': {
        fill: theme('colors.action-blue'),
      },
    });
  })
];